import 'magnific-popup'

export default {
	init() {

		let headerGallery = $(".header-gallery")
		
		if (headerGallery.length) {
			headerGallery.magnificPopup({
				delegate: ".slick-slide:not(.slick-cloned) a",
				type: "image",
				closeOnContentClick: false,
				closeBtnInside: false,
				mainClass: "mfp-with-zoom mfp-img-mobile",
				image: {
					verticalFit: true,
					titleSrc: function (item) {
						if (item.el.data("description") && item.el.attr("title")) {
							console.log(item.el.attr("title"))
							console.log(item.el.data("description"))
							return (
								item.el.attr("title") + " | " + item.el.data("description")
							)
						} else if (item.el.attr("title")) {
							return item.el.attr("title")
						} else if (item.el.data("description")) {
							return item.el.data("description")
						}
					},
				},
				gallery: {
					enabled: true,
				},
				zoom: {
					enabled: true,
					duration: 300, // don't foget to change the duration also in CSS
					opener: function (element) {
						return element.find("img")
					},
				},
			})
		}

	}
}
